import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Download = (props: SVGIcon) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      d="M15.031 10.5c.259 0 .469.21.469.469v2.812c0 .948-.77 1.719-1.719 1.719H2.22C1.27 15.5.5 14.73.5 13.781V10.97c0-.259.21-.469.469-.469s.469.21.469.469v2.812c0 .43.35.781.78.781h11.563c.43 0 .781-.35.781-.78v-2.813c0-.259.21-.469.47-.469zM8 .5c.259 0 .469.21.469.469l-.001 8.556 1.701-1.7c.183-.184.48-.184.664 0 .183.183.183.48 0 .663l-2.5 2.5-.02.017-.031.026.05-.044c-.025.026-.054.048-.083.067-.017.01-.035.02-.054.028l-.024.011c-.02.008-.04.014-.062.02l-.021.004c-.024.004-.049.007-.074.008H8c-.03 0-.059-.003-.087-.008l.087.008c-.037 0-.073-.004-.109-.013-.021-.005-.042-.011-.062-.02l-.022-.008c-.02-.01-.04-.02-.06-.033l-.02-.013L7.682 11l-.012-.013-2.5-2.5c-.183-.183-.183-.48 0-.663.183-.183.48-.183.663 0l1.699 1.7V.969C7.531.71 7.741.5 8 .5z"
    />
  </svg>
)
